export default "__VITE_ASSET__BrnK13G9__"